// Centralized Environment & URL Configuration for Xora Main Web

const getBackendUrl = () => {
    // 1. Check env variables from .env (including FRONTEND_URL & BASE_URL)
    if (process.env.FRONTEND_URL) return process.env.FRONTEND_URL;
    if (process.env.BASE_URL) return process.env.BASE_URL;
    if (process.env.REACT_APP_FRONTEND_URL) return process.env.REACT_APP_FRONTEND_URL;
    if (process.env.REACT_APP_BACKEND_URL) return process.env.REACT_APP_BACKEND_URL;
    if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '');

    // 2. Browser origin fallback for production deployment
    if (typeof window !== 'undefined' && window.location) {
        if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
            return window.location.origin;
        }
    }

    // 3. Local development fallback
    return 'http://localhost:8000';
};

export const BACKEND_URL = getBackendUrl();
export const API_URL = `${BACKEND_URL.replace(/\/$/, '')}/api`;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || BACKEND_URL;
